"use client";

import { useActionState } from "react";
import { useFormStatus } from "react-dom";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";

import { loginAction, type LoginActionState } from "@/actions/auth";

function SubmitButton() {
  const { pending } = useFormStatus();
  return (
    <Button type="submit" className="w-full" disabled={pending}>
      {pending ? "Входим..." : "Войти"}
    </Button>
  );
}

export default function LoginPage() {
  const [state, formAction] = useActionState<LoginActionState, FormData>(loginAction, {
    error: null,
    username: "",
  });

  return (
    <div className="min-h-[calc(100vh-2rem)] flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-sm">
        <CardHeader className="space-y-2">
          <CardTitle>Вход</CardTitle>
          <CardDescription>Введите имя пользователя и пароль.</CardDescription>
        </CardHeader>
        <CardContent>
          <form className="space-y-4" action={formAction}>
            <Input
              label="Имя пользователя"
              id="username"
              name="username"
              autoComplete="username"
              defaultValue={state.username}
              required
            />
            <Input
              label="Пароль"
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
            />
            {state.error && (
              <p className="text-sm text-destructive">Неверный пароль или имя пользователя.</p>
            )}
            <SubmitButton />
            <p className="text-xs text-muted-foreground">
              Регистрация отключена. Обратитесь к суперпользователю.
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
